export type TierKey = 'S' | 'A' | 'B' | 'C' | 'D' | 'F';

export const TIER_KEYS: TierKey[] = ['S', 'A', 'B', 'C', 'D', 'F'];

export const UNRANKED_KEY = '_unranked';

export interface TierStyle {
  label: string;
  accent: string;
}

// 全体のダークUIに馴染ませた、やや彩度を抑えたアクセント色
export const TIER_STYLES: Record<TierKey, TierStyle> = {
  S: { label: 'S', accent: '#ef6171' },
  A: { label: 'A', accent: '#f0925a' },
  B: { label: 'B', accent: '#e7bd5a' },
  C: { label: 'C', accent: '#6cb787' },
  D: { label: 'D', accent: '#5e9fcf' },
  F: { label: 'F', accent: '#8a8a98' },
};

export const isTierKey = (v: unknown): v is TierKey =>
  typeof v === 'string' && (TIER_KEYS as string[]).includes(v);
